import Cookies from 'js-cookie'
import { authAPI } from '@/api/auth'
import md5 from 'js-md5'
import { storageUtils } from '@/utils/storage'
import { getUserMenuPermissions } from '@/utils/menu'

const state = {
  token: Cookies.get('token') || '',
  name: Cookies.get('userName') || localStorage.getItem('userName') || '',
  avatar: '',
  roles: [],
  userInfo: null,
  menuPermissions: [] // 用户菜单权限
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_MENU_PERMISSIONS: (state, permissions) => {
    state.menuPermissions = permissions
  }
}

const actions = {
  // 用户登录
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      // 对密码进行MD5加密
      const loginData = {
        username: userInfo.username,
        password: md5(userInfo.password)
      }
      
      authAPI.adminLogin(loginData).then(response => {
        // 登录接口返回的data就是token和userToken
        const token = response.data
        
        commit('SET_TOKEN', token)
        const userName = userInfo.username // 使用实际登录的用户名
        
        // 使用工具函数存储用户数据
        storageUtils.setUserData({ token, userName })
        
        // 登录成功后，token就是response.data
        commit('SET_USER_INFO', { token })
        commit('SET_NAME', userName)
        commit('SET_AVATAR', 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif')
        commit('SET_ROLES', ['admin']) // 默认角色，后续通过getU接口获取
        
        // 登录时暂时不设置菜单权限，等getU接口返回后再设置
        commit('SET_MENU_PERMISSIONS', [])
        
        resolve({ token })
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取用户信息
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (!state.token) {
        reject('No token')
        return
      }
      
      authAPI.getUserInfo(state.token).then(response => {
        const { data } = response
		console.log('---990',data);
        const userName = data.name || data.username || data.userName || 'Admin'
        
        // 使用工具函数更新用户数据
        storageUtils.setUserData({ userName })
        
        commit('SET_USER_INFO', data)
        commit('SET_NAME', userName)
        commit('SET_AVATAR', data.avatar || 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif')
        commit('SET_ROLES', data.roles || ['admin'])
        
        // 更新用户菜单权限
        const menuPermissions = getUserMenuPermissions(data)
        commit('SET_MENU_PERMISSIONS', menuPermissions)
        
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 用户登出
  logout({ commit }) {
    return new Promise((resolve) => {
      // 尝试调用登出API，如果失败也继续执行本地登出
      authAPI.logout().catch(() => {
        // API调用失败时忽略错误，继续执行本地登出
        console.log('登出API调用失败，执行本地登出')
      }).finally(() => {
        // 无论API调用成功与否，都执行本地登出
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_USER_INFO', null)
        commit('SET_NAME', '')
        commit('SET_AVATAR', '')
        commit('SET_MENU_PERMISSIONS', [])
        
        // 使用工具函数清理所有用户数据
        storageUtils.clearUserData()
        
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}